module.exports = __webpack_public_path__ + "img/icon_cat_schedule.a590c51.png";